module.exports = kolibriGlobal.coreVue.components.KRadioButton;